import { cidsActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_CID,
  FETCHING_CID,
  FETCH_CID_ERROR,
  FETCH_CIDS,
  FETCHING_CIDS,
  FETCH_CIDS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_CID,
  DELETE_CID,
  ADD_CID,
  EDIT_CID,
  FORM_TOUCHED,
  NEW_FORM_CID,
  CID_FORM_ERROR,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  RESET_STATE
} = cidsActions

const initialState = {
  loadingCid: false,
  loadingCids: false,
  fetchCidError: false,
  fetchCidsError: false,
  cids: [],
  order: {
    column: 'nome',
    direction: 1
  },
  cid: {
    nome: '',
    codigo: '',
    tipo: ''
  },
  cidsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  cidFormErrors: {},
  cidFormTouched: false,
  modalOpen: false
}

const cidSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    codigo: {
      required: true
    },
    tipo: {
      required: true
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    codigo: {
      required: true
    },
    tipo: {
      required: true
    }
  }
}

const CidValidate = new ValidateFormObject(cidSchema)

const cids = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_CID:
      formSchemaType = action.cid._id ? 'edit' : 'add'
      return {
        ...state,
        cid: action.cid,
        cidFormErrors: CidValidate.validate({
          formObject: action.cid,
          formSchemaType
        })
      }
    case CID_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.cid._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        cidFormErrors: CidValidate.validate({
          formObject: state.cid,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_CID:
      return {
        ...state,
        cid: { ...initialState.cid },
        cidFormErrors: CidValidate.validate({}),
        cidFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        cidFormTouched: true
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_CID:
      formSchemaType = (action.cid || {})._id ? 'edit' : 'add'
      return {
        ...state,
        cid: action.cid,
        loadingCid: false,
        fetchCidError: false,
        cidFormTouched: false,
        cidFormErrors: CidValidate.validate({
          formObject: action.cid,
          formSchemaType
        })
      }
    case FETCHING_CID:
      return {
        ...state,
        loadingCid: true,
        fetchCidError: false
      }
    case DELETE_CID:
      return {
        ...state,
        loadingCids: false,
        fetchCidError: false,
        cids: state.cids.map(cid => {
          if (cid._id === action.cid._id) {
            cid = action.cid
          }
          return cid
        })
      }
    case FETCH_CID_ERROR:
      return {
        ...state,
        loadingCid: false,
        cid: { ...initialState.cid },
        fetchCidError: action.error
      }
    case CHANGE_PAGE:
      return {
        ...state,
        cidsPagination: {
          ...state.cidsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        cidsPagination: {
          ...state.cidsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_CIDS:
      return {
        ...state,
        loadingCids: false,
        cids: action.cids,
        fetchCidsError: false,
        order: action.order,
        cidsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_CID:
      return {
        ...state,
        cids: state.cids.map(cid => {
          if (cid._id === action.cid._id) {
            return action.cid
          }
          return cid
        }),
        loadingCids: false,
        fetchCidError: false,
        loadingCid: false,
        fetchCidsError: false
      }
    case FETCHING_CIDS:
      return {
        ...state,
        loadingCids: true,
        fetchCidsError: false
      }
    case FETCH_CIDS_ERROR:
      return {
        ...state,
        loadingCids: false,
        fetchCidError: action.error,
        loadingCid: false
      }
    case ADD_CID:
      return {
        ...state,
        loadingCids: false,
        fetchCidError: false,
        loadingCid: false,
        cids: [...state.cids, action.cid]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default cids



// WEBPACK FOOTER //
// ./src/reducers/cids.js